import * as I18n from 'circe/I18n';

import * as Types from './actionTypes';

const initialState = {
  distance: I18n.str('na', 'Not Available'),
  duration: I18n.str('na', 'Not Available'),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.UPDATE_DISTANCE: {
      const {
        payload: { distance },
      } = action;
      return { ...state, distance };
    }
    case Types.UPDATE_DURATION: {
      const {
        payload: { duration },
      } = action;
      return { ...state, duration };
    }
    default:
      return state;
  }
};
